import { Modal, ProgressBar } from '../../../components/BootstrapToMUI';
import '../../items/formFields.css';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import { Grid, Box, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Controller, useForm } from 'react-hook-form';
import { DeleteForeverOutlined, CloudUpload } from '@mui/icons-material';

const SIZELIMIT = 10000000;

export default function AddAudio(props) {
  const { _id, user } = props;
  const theme = useTheme();
  const [e1, setE1] = useState('');
  const [e2, setE2] = useState('');
  const [percent, setPercent] = useState(0);

  const [fileNames, setFileNames] = useState({});

  const defaultValues = {
    name: '',
    start: '',
    cart: '',
    checkout: '',
    dispense: '',
    doorOpen: '',
    doorClose: '',
  };

  const {
    handleSubmit,
    control,
    register,
    setError,
    clearErrors,
    getValues,
    setValue,
    formState: { errors },
    watch,
    reset,
  } = useForm({ defaultValues });

  const watchAllFields = watch();

  const handleRemove = (input) => {
    setPercent(0);
    setValue(input);
    fileNames[input] = null;
  };

  const onSubmit = (formData) => {
    const myData = new FormData();
    // if (fileNames.start) myData.append('startAudio', fileNames.start);
    // if (fileNames.cart) myData.append('cartAudio', fileNames.cart);
    // if (fileNames.checkout) myData.append('checkoutAudio', fileNames.checkout);
    // if (fileNames.dispense) myData.append('dispenseAudio', fileNames.dispense);
    // if (fileNames.doorOpen) myData.append('doorOpenAudio', fileNames.doorOpen);
    // if (fileNames.doorClose) myData.append('doorCloseAudio', fileNames.doorClose);
    myData.append('name', formData.name);
    myData.append('referTo', _id);
    if (formData.start && formData.start.length > 0) myData.append('start', formData.start[0]);
    if (formData.cart && formData.cart.length > 0) myData.append('cart', formData.cart[0]);
    if (formData.checkout && formData.checkout.length > 0)
      myData.append('checkout', formData.checkout[0]);
    if (formData.dispense && formData.dispense.length > 0)
      myData.append('dispense', formData.dispense[0]);
    if (formData.doorOpen && formData.doorOpen.length > 0)
      myData.append('doorOpen', formData.doorOpen[0]);
    if (formData.doorClose && formData.doorClose.length > 0)
      myData.append('doorClose', formData.doorClose[0]);

    request({
      method: 'post',
      url: `/audio/create`,
      data: myData,
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        if (percent < 100) {
          setPercent(percent);
        }
      },
    })
      .then((res) => {
        setPercent(100, () => {
          setTimeout(() => {
            setPercent(0);
          }, 1000);
        });
        Swal.fire({
          text: `New product has been successfully updated`,
          icon: 'success',
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 406) {
            setError('category', {
              message: err.response.data.message,
            });
          } else {
            Swal.fire({
              text: err.response?.data?.error,
              icon: 'error',
            });
          }
        }
      });
  };

  // Reusable upload field component
  const UploadField = ({ name, label, fieldName }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: theme.palette.text.primary }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          variant="contained"
          component="label"
          startIcon={<CloudUpload />}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 2,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          }}
        >
          Upload
          <input
            {...register(fieldName, {
              validate: (value) => {
                if (value && value[0] && value[0].size > SIZELIMIT) {
                  return 'File size too big, please provide the right size.';
                }
                return true;
              },
              onChange: () => {
                clearErrors(fieldName);
                setPercent(0);
                fileNames[fieldName] = null;
              },
            })}
            type="file"
            accept=".wav"
            hidden
          />
        </Button>
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            color: theme.palette.text.secondary,
            fontFamily: 'monospace',
            fontSize: '0.85rem',
          }}
        >
          {watchAllFields[fieldName] && watchAllFields[fieldName].length > 0
            ? watchAllFields[fieldName][0].name
            : fileNames[fieldName] || 'No file selected'}
        </Typography>
        {(fileNames[fieldName] || (watchAllFields[fieldName] && watchAllFields[fieldName].length > 0)) && (
          <IconButton
            onClick={() => handleRemove(fieldName)}
            size="small"
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
              },
            }}
          >
            <DeleteForeverOutlined />
          </IconButton>
        )}
      </Box>
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: theme.palette.error.main, mt: 0.5, display: 'block' }}>
          {errors[fieldName].message}
        </Typography>
      )}
    </Box>
  );

  return (
    <Modal className="modal-w" {...props} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Add New Audio</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: 2, '& .MuiTextField-root': { mb: 2 } }}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                label="Name"
                variant="outlined"
                required
                fullWidth
                {...field}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            )}
          />
          {errors.name && (
            <Typography variant="caption" sx={{ color: theme.palette.error.main, mt: -1.5, mb: 2, display: 'block' }}>
              {errors.name.message}
            </Typography>
          )}

          <UploadField
            name="start"
            label="Touch The Screen To Start A Transaction"
            fieldName="start"
          />

          {user?.features?.extra && (
            <UploadField
              name="cart"
              label="Open Shopping Cart"
              fieldName="cart"
            />
          )}

          <UploadField
            name="checkout"
            label="Tap On Check Out"
            fieldName="checkout"
          />

          <UploadField
            name="dispense"
            label="During Dispense"
            fieldName="dispense"
          />

          <UploadField
            name="doorOpen"
            label="Door Opens"
            fieldName="doorOpen"
          />

          <UploadField
            name="doorClose"
            label="After Door Closes"
            fieldName="doorClose"
          />

          {e1 !== '' && (
            <Typography variant="caption" sx={{ color: theme.palette.error.main, display: 'block', mb: 1 }}>
              {e1}
            </Typography>
          )}

          {e2 !== '' && (
            <Typography variant="caption" sx={{ color: theme.palette.error.main, display: 'block', mb: 1 }}>
              {e2}
            </Typography>
          )}

          {percent > 0 && (
            <Box sx={{ mb: 2 }}>
              <ProgressBar now={percent} label={`${percent}%`} />
            </Box>
          )}

          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 2 }}>
            Only WAV format is accepted. File size cannot exceed 20MB.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
              '&:hover': {
                boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
              },
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
